import { useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { FerryReturnIcon, RoroFerryIcon } from '@dfds-frontend/navigator-icons/icons'

import { useRoutes } from '../../Hooks/routes/useRoutes'

import { ActiveSelectField, useActiveSelectField } from '../../context/ActiveSelectFieldProvider'
import { useTravelSearchContext } from '../../context/TravelSearchProvider'
import SelectField from '../shared/SelectField'
import RoutesWithSearch from './Routes'

type Props = {
  travelSearchRef: React.RefObject<HTMLDivElement>
}

const RoutesSelector = ({ travelSearchRef }: Props) => {
  const routeTriggerRef = useRef<HTMLButtonElement>(null)
  const {
    dispatch,
    state: { isOneWay },
  } = useTravelSearchContext()
  const { activeField, closeIfActive, toggleField } = useActiveSelectField()

  const { t } = useTranslation()
  const { isRoutesLoading, routesApiData, selectedRoute } = useRoutes()

  return (
    <div className="col-span-12 box-border h-[58px] w-full md:col-span-6 lg:flex-1">
      <SelectField
        className="lg:border-r-0"
        dataAttrList={[
          { name: 'selected-route', value: `${selectedRoute?.routeCode}` },
          {
            name: 'selected-salesowner',
            value: `${selectedRoute?.salesOwner}`,
          },
        ]}
        disabled={routesApiData?.categories?.reduce((count, current) => count + current.routes.length, 0) === 1}
        fieldName="route"
        icon={isOneWay ? <RoroFerryIcon size="md" /> : <FerryReturnIcon size="md" />}
        isLoading={isRoutesLoading}
        isOpen={activeField === ActiveSelectField.ROUTE}
        onClick={(clickedOutside: boolean) => {
          !isRoutesLoading && toggleField(ActiveSelectField.ROUTE, clickedOutside)
        }}
        onClose={() => {
          closeIfActive(ActiveSelectField.ROUTE)
        }}
        title={t('ROUTE')}
        triggerRef={routeTriggerRef}
        value={selectedRoute?.name}
      >
        <RoutesWithSearch
          onEscape={() => {
            closeIfActive(ActiveSelectField.ROUTE)
            requestAnimationFrame(() => routeTriggerRef.current?.focus())
          }}
          onSelectRoute={(route, restoreFocus) => {
            dispatch({
              route: {
                name: route?.name,
                returnRequired: route.returnRequired,
                routeCode: route.routeCode,
                salesOwner: route.salesOwner,
              },
              type: 'SET_ROUTE',
            })
            closeIfActive(ActiveSelectField.ROUTE)
            if (restoreFocus) {
              requestAnimationFrame(() => routeTriggerRef.current?.focus())
            }
          }}
          routeCategories={routesApiData?.categories ?? []}
          selectedRoute={selectedRoute}
          travelSearchRef={travelSearchRef}
        />
      </SelectField>
    </div>
  )
}
export default RoutesSelector
